const PRICING_DETAILS = [
  { key: 'msrp', label: 'MSRP' },
  { key: 'price', label: 'Retail' },
  { key: 'unitCost', label: 'Cost', roles: ['ADMIN', 'MANAGER'] }, // SHOW ONLY TO MANAGER AND ABOVE
];

const OTHER_DETAILS = [
  { key: 'posRefNum', label: 'POS ID' },
  { key: 'upc', label: 'UPC' },
];

const PRODUCT_DETAILS = [
  { key: 'stoneType', label: 'Type' },
  { key: 'stoneClarity', label: 'Clarity' },
  { key: 'stoneShape', label: 'Shape' },
  { key: 'stoneSize', label: 'Size' },
  { key: 'stoneColor', label: 'Color' },
  { key: 'totalDiaWt', label: 'Total Diamond Weight' },
  { key: 'pattern', label: 'Pattern' },
  { key: 'color', label: 'Color' },
  { key: 'material', label: 'Material' },
];

export const PRODUCT_DETAILS_SECTIONS = [
  {
    label: 'Pricing',
    items: PRICING_DETAILS,
    itemType: 'number',
  },
  {
    label: 'Other',
    items: OTHER_DETAILS,
    itemType: 'string',
  },
  {
    label: 'Details',
    items: PRODUCT_DETAILS,
    itemType: 'string',
  },
];
